import { render, staticRenderFns } from "./deliveryareaaddressSetting_new.vue?vue&type=template&id=cf18c432&scoped=true"
import script from "./deliveryareaaddressSetting_new.vue?vue&type=script&lang=js"
export * from "./deliveryareaaddressSetting_new.vue?vue&type=script&lang=js"
import style0 from "./deliveryareaaddressSetting_new.vue?vue&type=style&index=0&id=cf18c432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf18c432",
  null
  
)

export default component.exports